document.addEventListener('DOMContentLoaded', function () {
    if (!window.swiperInstances) {
        window.swiperInstances = [];
    }
    
    document.querySelectorAll('.product-card-swiper').forEach(function (element) {
        if (!element.swiper) {
            const swiper = new Swiper(element, {
                slidesPerView: 1,
                grabCursor: true,
                keyboard: {
                    enabled: true,
                },
                scrollbar: {
                    el: element.querySelector('.swiper-scrollbar'),
                    draggable: true,
                    clickable: true,
                },
            });
            
            // Store the instance globally
            window.swiperInstances.push(swiper);
        }
    });
});